import dynamic from 'next/dynamic';

const BookingsGrid = dynamic(() => import('./BookingsGrid/BookingsGrid'));

const BookingsHeaderOptions = dynamic(() =>
  import('./BookingsHeaderOptions/BookingsHeaderOptions')
);
const NewBookingModal = dynamic(() =>
  import('./NewBookingModal/NewBookingModal')
);
const NewBookingForm = dynamic(() => import('./NewBookingForm/NewBookingForm'));
const BookingForm = dynamic(() => import('./BookingForm/BookingForm'));
const BookingProductsGrid = dynamic(() =>
  import('./BookingProductsGrid/BookingProductsGrid')
);
const BookingsFilters = dynamic(() =>
  import('./BookingsFilters/BookingsFilters')
);
const BookingsListContent = dynamic(() =>
  import('./BookingsListContent/BookingsListContent')
);

const BookingTicketDetails = dynamic(() =>
  import('./BookingTicketDetails/BookingTicketDetails')
);

const BookingDetailTitle = dynamic(() =>
  import('./BookingDetailTitle/BookingDetailTitle')
);
const BookingProducts = dynamic(() =>
  import('./BookingProducts/BookingProducts')
);
const BookingDetails = dynamic(() => import('./BookingDetails/BookingDetails'));

const AddBillingInfoModal = dynamic(() =>
  import('./AddBillingInfoModal/AddBillingInfoModal')
);

const BookingGuarantor = dynamic(() =>
  import('./BookingGuarantor/BookingGuarantor')
);
const BookingGuarantorForm = dynamic(() =>
  import('./BookingGuarantorForm/BookingGuarantorForm')
);
const EditGuarantorInfoModal = dynamic(() =>
  import('./EditGuarantorInfoModal/EditGuarantorInfoModal')
);

const BookingLinkedOffers = dynamic(() =>
  import('./BookingLinkedOffers/BookingLinkedOffers')
);
const BookingsPreleadsForm = dynamic(() =>
  import('./BookingsPreleadsForm/BookingsPreleadsForm')
);
const BookingHistory = dynamic(() => import('./BookingHistory/BookingHistory'));

const BookingsGridAutocompleteCell = dynamic(() =>
  import('./BookingsGridAutocompleteCell/BookingsGridAutocompleteCell')
);

const BookingSelectCustomerTypeModal = dynamic(() =>
  import('./BookingSelectCustomerTypeModal/BookingSelectCustomerTypeModal')
);

const BookingLinkedGrid = dynamic(() =>
  import('./BookingLinkedGrid/BookingLinkedGrid')
);

const BookingLostModal = dynamic(() =>
  import('./BookingLostModal/BookingLostModal')
);

const BookingPromisedDeliveryDateModal = dynamic(() =>
  import('./BookingPromisedDeliveryDateModal/BookingPromisedDeliveryDateModal')
);

export {
  BookingsGrid,
  BookingsHeaderOptions,
  NewBookingModal,
  NewBookingForm,
  BookingProductsGrid,
  BookingsFilters,
  BookingsListContent,
  BookingTicketDetails,
  BookingForm,
  BookingDetailTitle,
  AddBillingInfoModal,
  BookingGuarantor,
  BookingGuarantorForm,
  EditGuarantorInfoModal,
  BookingProducts,
  BookingDetails,
  BookingLinkedOffers,
  BookingsPreleadsForm,
  BookingHistory,
  BookingsGridAutocompleteCell,
  BookingSelectCustomerTypeModal,
  BookingLinkedGrid,
  BookingLostModal,
  BookingPromisedDeliveryDateModal,
};
